import { render, staticRenderFns } from "./mypolicydetail.vue?vue&type=template&id=5919f0a8&scoped=true"
import script from "./mypolicydetail.vue?vue&type=script&lang=js"
export * from "./mypolicydetail.vue?vue&type=script&lang=js"
import style0 from "./mypolicydetail.vue?vue&type=style&index=0&id=5919f0a8&prod&lang=scss&scoped=true"
import style1 from "./mypolicydetail.vue?vue&type=style&index=1&id=5919f0a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919f0a8",
  null
  
)

export default component.exports